/*
  Mad Olive - staged "Gift Guide" navigation link.

  Adds a top-level "Gift Guide" link (to the Gift Guide blog) to the header
  navigation without touching the shared "mega-menu" (which the live theme also
  uses). Runs on the Expanse theme only, since it's loaded from this theme's
  layout. Appends to both the desktop nav and the mobile slide-out nav, and
  retries briefly in case the header hydrates after first paint.
*/
(function () {
  var HREF = '/blogs/gift-guide';
  var LABEL = 'GIFT GUIDE';

  function addTo(nav, liClass, linkClass, wrapSpan) {
    if (!nav || nav.querySelector('.mo-gift-guide')) return;
    var li = document.createElement('li');
    li.className = liClass + ' mo-gift-guide';
    var inner = wrapSpan ? '<span>' + LABEL + '</span>' : LABEL;
    li.innerHTML = '<a href="' + HREF + '" class="' + linkClass + '">' + inner + '</a>';
    nav.appendChild(li);
  }

  function run() {
    var desktops = document.querySelectorAll('ul.site-navigation');
    for (var i = 0; i < desktops.length; i++) {
      addTo(desktops[i], 'site-nav__item site-nav__expanded-item', 'site-nav__link site-nav__link--underline', false);
    }
    var mobiles = document.querySelectorAll('ul.slide-nav');
    for (var j = 0; j < mobiles.length; j++) {
      addTo(mobiles[j], 'slide-nav__item', 'slide-nav__link', true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Safety net for late header hydration.
  var tries = 0;
  var iv = setInterval(function () {
    run();
    if (++tries > 20) clearInterval(iv);
  }, 250);
})();
